import { Button, Modal, spacing, Typography } from "@procore/core-react";
import { useTranslation } from "react-i18next";

import { trapFocusWithoutDismiss } from "./guidanceModalLock";

type IgnoreConfirmationProps = {
    busy?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

/** Figma: BIM — Windows GPU Wizard, confirm ignore 540×284 with 32px content inset. */
const CONFIRM_DIALOG_WIDTH = 540;

export function IgnoreConfirmation({ busy = false, onConfirm, onCancel }: IgnoreConfirmationProps) {
    const { t } = useTranslation();

    return (
        <Modal
            open
            role="dialog"
            howToClose={busy ? [] : ["x", "scrim"]}
            onClose={busy ? trapFocusWithoutDismiss : onCancel}
            style={{
                width: CONFIRM_DIALOG_WIDTH,
                maxWidth: CONFIRM_DIALOG_WIDTH,
            }}
        >
            <Modal.Header
                style={{
                    padding: `${spacing.xxl}px ${spacing.xxl}px ${spacing.lg}px`,
                }}
            >
                <Modal.Heading style={{ fontWeight: "bold" }}>{t("gpuGuidance.ignoreConfirm.title")}</Modal.Heading>
            </Modal.Header>
            <Modal.Body
                style={{
                    padding: spacing.xxl,
                    maxWidth: "none",
                }}
            >
                <Typography intent="body">{t("gpuGuidance.ignoreConfirm.body")}</Typography>
            </Modal.Body>
            <Modal.Footer
                style={{
                    padding: `${spacing.xl}px ${spacing.xxl}px ${spacing.xxl}px`,
                }}
            >
                <Modal.FooterButtons>
                    <Button variant="tertiary" onClick={onCancel} disabled={busy}>
                        {t("cancel")}
                    </Button>
                    <Button variant="primary" onClick={onConfirm} disabled={busy}>
                        {t("gpuGuidance.ignore")}
                    </Button>
                </Modal.FooterButtons>
            </Modal.Footer>
        </Modal>
    );
}
